export default __webpack_public_path__ + "static/media/pandl.9a982f51.png";